import { AttoCollegato, SectionVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';

export const transformerAttoCollegatoList = (
  dataSections?: Array<SectionVM>
): Array<AttoCollegato> | undefined => {
  if ((dataSections || []).length === 0) {
    return undefined;
  }

  return dataSections?.map((dataSection) => {
    const actForm = dataSection.actForm || {};

    const isOtherMunicipality = actForm.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

    return {
      key: dataSection.idAttoCollegato
        ? {
            idAttoCollegato: dataSection.idAttoCollegato,
          }
        : undefined,
      tipoAttoPresentato: dataSection.typeAct || undefined,
      idComuneRegistrazione: actForm.italian?.municipality?.code?.toString()
        ? Number.parseInt(actForm.italian?.municipality?.code.toString(), 10)
        : undefined,
      nomeComuneRegistrazione: isOtherMunicipality
        ? actForm.italian?.otherMunicipality || undefined
        : actForm.italian?.municipality?.description,
      idProvRegistrazione: actForm.italian?.municipality?.idProvince || undefined,
      siglaProvRegistrazione: actForm.italian?.municipality?.province || undefined,
      idAnsc: actForm.idAnsc || undefined,
      tipoContenuto: actForm.typeEvent || undefined,
      numeroAtto: actForm.municipalNumber
        ? Number.parseInt(actForm.municipalNumber, 10)
        : undefined,
      annoAtto: actForm.year ? Number.parseInt(actForm.year, 10) : undefined,
      dataFormazioneAtto: actForm.dateAct ? actForm.dateAct.toFormat('yyyy-MM-dd') : undefined,
      tipologiaAtto: actForm.register || undefined,
      parteAtto: actForm.portion || undefined,
      serieAtto: actForm.serie || undefined,
      volumeAtto: actForm.volume || undefined,
      tipoSezione: dataSection?.typePersistence || undefined,
      sezione: dataSection.codeSection || undefined,
      tipoPersistenza: dataSection?.typePersistence || undefined,
    };
  });
};
